import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useAppContext } from "../../../_context";
import TimelineSectionContent from "./TimelineSectionContent";

const TimelineSection = ({ data, nEmployees }) => {
  const [{ tx }] = useAppContext();

  return (
    <section className="timeline-section section-padding-y">
      <Container>
        <Row className="justify-content-between">
          <Col
            md={4}
            className="d-flex grey-shadow align-items-center grey-highlight">
            <div className="py-7 position-relative">
              <h2>{tx["Our journey so far"]}</h2>
              <h4 className="text-grey-1 mb-0 fw-normal">
                {
                  tx[
                    "RacketPal was created by racket sports players for racket sports players. Our humble journey started one random night when a tennis player and a squash player met..."
                  ]
                }
              </h4>
            </div>
          </Col>
          <Col md={8}>
            <TimelineSectionContent data={data} nEmployees={nEmployees} />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TimelineSection;
